import Select from "../../../../form/Select";
import React from "react";
import {optionsTemplate} from "../../../../../utils/formatters";
import debounce from "../../../../../utils/debounce";
import {connect} from "src/store";

export class Source extends React.Component {

    constructor(props) {
        super(props);
        this.change = debounce((field, value) => {
            props.setFieldValue && props.setFieldValue(field, value);
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const propsTop = {...this.props};
        const {props} = propsTop;
        const prevPropsTop = {...prevProps};
        const pProps = prevPropsTop.props;
        if (props.values.id + "" === "" + pProps?.id && props.values.seller?.partner_id + "" !== "" + pProps.values.seller?.partner_id) {
            this.change("source", null);
        }
    }

    render() {
        const propsTop = {...this.props};
        const {props, state, parent} = propsTop;
        const {hidden, labels} = props;
        const sourceProps = props.getProps("source");
        let filter = [{
            fields: ["id","store"]
        }];
        let filterFields = this.props.filterFields || ["seller"];
        if (filterFields.some((field) => !!props.values[field])) {
            let filters = filterFields.filter((field) => !!props.values[field]).map((field) => ({
                field: "partner", value: props.values[field].partner_id
            }));
            if (this.props.partner.partner_id + "" === "" + props.values.seller.partner_id) {
                filters.push({
                    field: "store.serviceprovider", value: "linked_store"
                })
            }
            filter = [
                ...filter,
                {
                    filters,
                    operator: "OR"
                }
            ];
        }

        return (hidden || []).indexOf("source") === -1 && (!!props.values.seller || this.props.visible) ? <Select
            label={labels.source || "Honnan"}
            name="source"
            component="location"
            objectValue={true}
            autoSelect={true}
            labelKey="name"
            storeType="local"
            filter={filter}
            optionsTemplate={optionsTemplate("location")}
            {...sourceProps}
            disabled={sourceProps.disabled || propsTop.disabled}
            value={props.getValue("source")}
            saveChanges={props.setFieldValue}
        /> : null;
    }
}

export default connect((state) => {
    return {
        partner: state.app.context.partner
    }
})(Source);